export default {
  MARRONNIER_PRODUITS: "Page_Marronniers_Produits",
  MARRONNIER_RAYONS: "Page_Marronniers_Rayons",
  MARRONNIERS: "PageMarroniers"
}
